import type { FavoriteViewSearch } from './favoriteView'

function getProductPath(search: FavoriteViewSearch): string | null {
  const { hierarchy, routeContext } = search

  if (!routeContext)
    return null

  const basePath = `/${search.season}/universe/${routeContext.universeId}/department/${routeContext.departmentId}`

  if ('departmentId' in hierarchy)
    return `${basePath}/all-families`

  if ('subdepartmentId' in hierarchy) {
    return `${basePath}/subdepartment/${hierarchy.subdepartmentId}/families`
  }

  if (routeContext.familyPath === 'subdepartments' || !routeContext.subdepartmentId)
    return `${basePath}/subdepartments/families`

  if (routeContext.familyPath === 'full-subdepartment')
    return `${basePath}/subdepartment/${routeContext.subdepartmentId}/full/families`

  return `${basePath}/subdepartment/${routeContext.subdepartmentId}/families`
}

export function buildFavoriteViewUrl(search: FavoriteViewSearch): string | null {
  const pathname = getProductPath(search)

  if (!pathname)
    return null

  const searchParams = new URLSearchParams()

  if ('familyIds' in search.hierarchy) {
    search.hierarchy.familyIds.forEach(id => searchParams.append('families', String(id)))
  }

  if (search.resource === 'MODELS')
    searchParams.set('viewMode', 'model')
  else
    searchParams.set('viewMode', 'sm')

  for (const [name, value] of Object.entries(search.filters)) {
    if (Array.isArray(value))
      value.forEach(item => searchParams.append(name, String(item)))
    else if (value)
      searchParams.set(name, 'true')
  }

  const [sort, order] = search.order.match(/^(.*)_(ASC|DESC)$/i)?.slice(1) ?? []
  if (sort && order) {
    searchParams.set('sort', sort.toLowerCase())
    searchParams.set('order', order.toLowerCase())
  }

  return `${pathname}?${searchParams.toString()}`
}
